export class Lesson {
  id: number
  lesson_code: string
  subject_code: string
  nendo: number
  name: string
  goal_comment: string
  message: string
  tantou_login_id: string
  tantou_user_name: string
  lesson_classes: LessonClass[] = []

  constructor(x: any){
    this.id = x.id;
    this.lesson_code = x.lesson_code;
    this.subject_code = x.subject_code;
    this.nendo = x.nendo;
    this.name = x.name;
    this.goal_comment = x.goal_comment;
    this.message = x.message;
    this.tantou_login_id = x.tantou_login_id;
    this.tantou_user_name = x.tantou_user_name;
    x.lesson_classes.forEach((lesson_class: any) => {
      if(lesson_class){
        this.lesson_classes.push(new LessonClass(lesson_class));
      }else{
        this.lesson_classes.push(null);
      }
    });
  }
}

export class LessonClass {
  id: number
  sheet_code: string
  lesson_class_no: number
  content: string
  start_datetime_at: Date
  end_datetime_at: Date
  is_published: boolean
  test_status: number
  kyouzai_status: number
  score: number
  
  constructor(x: any){
    if(x == null){
      return;
    }
    this.id = x.id;
    this.sheet_code = x.sheet_code;
    this.lesson_class_no = x.lesson_class_no;
    this.content = x.content;
    this.start_datetime_at = x.start_datetime_at;
    this.end_datetime_at = x.end_datetime_at;
    this.is_published = x.is_published;
    this.test_status = x.test_status;
    this.kyouzai_status = x.kyouzai_status;
    this.score = x.score;
  }
}